import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@mui/styles';
import defaultStyles from '../../../styles/views/mini-card';
import MiniCardBase from '../../../../view-widgets/mini-card/base';

function MiniCard({
  applet: {
    name, image, description, _meta: { username },
  },
  classes,
  ...otherProps
}) {
  return (
    <MiniCardBase
      imageURL={image && image.contentURL}
      title={name}
      subheader={`@${username}`}
      description={description}
      classes={classes}
      {...otherProps}
    />
  );
}

MiniCard.propTypes = {
  applet: PropTypes.shape({
    name: PropTypes.string.isRequired,
    brand: PropTypes.string,
    image: PropTypes.shape({
      contentURL: PropTypes.string,
      height: PropTypes.number,
      width: PropTypes.number,
    }),
    description: PropTypes.string,
    _meta: PropTypes.shape({
      username: PropTypes.string,
    }),
  }).isRequired,
  classes: PropTypes.shape({}).isRequired,
};

export default withStyles(defaultStyles)(MiniCard);
